import {
  forwardRef,
  useEffect,
  useState,
  ForwardRefRenderFunction,
  ReactNode,
  useImperativeHandle,
} from 'react';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  ModalContainer,
  ModalContainerPaper,
  ModalContainerTop,
  ModalContentContainer,
  ModalFooterContainer,
  ModalTitleContainer,
} from './styles';

export interface ImperativeModalHandler {
  open: () => void;
  close: () => void;
}

interface ImperativeModalProps {
  children: ReactNode;
  title?: string;
  hasCloseIcon?: boolean;
  width?: number;
  footer?: ReactNode;
}

const ImperativeModal: ForwardRefRenderFunction<
  ImperativeModalHandler,
  ImperativeModalProps
> = ({
  children,
  title,
  hasCloseIcon,
  width,
  footer
}, ref) => {
  const [openedModal, setOpenedModal] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setOpenedModal(true),
    close: () => setOpenedModal(false),
  }));

  // Trava a rolagem da página enquanto o modal está aberto, para a roda do
  // mouse não rolar o conteúdo que fica atrás do overlay.
  useEffect(() => {
    if (!openedModal) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [openedModal]);

  if (openedModal) {
    return (
      <ModalContainer>
        <ModalContainerPaper
          style={{ width: width ? `${width}px` : undefined }}
        >
          <ModalTitleContainer>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {title && <Typography variant='h6'>{title}</Typography>}
              {hasCloseIcon && (
                <ModalContainerTop>
                  <CloseIcon color='action' onClick={() => setOpenedModal(false)} />
                </ModalContainerTop>
              )}
            </div>
          </ModalTitleContainer>
          <ModalContentContainer>
            {children}
          </ModalContentContainer>
          {footer && <ModalFooterContainer>{footer}</ModalFooterContainer>}
        </ModalContainerPaper>
      </ModalContainer>
    );
  }

  return <></>;
};


export const ModalSubfield = forwardRef(ImperativeModal);
